import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { LoadDocumentType, LoadDocumentUpload } from '../../../models';
import {
  getLoadDocumentProcessed,
  LoadDocumentAddDocumentAction,
  LoadDocumentAddDocumentProcessedClearAction,
  SharedState,
} from '../../../store';
import { BaseComponent } from '../../base-component';

@Component({
  selector: 'kbxl-upload-document-modal',
  templateUrl: './upload-document-modal.component.html',
  styleUrls: ['./upload-document-modal.component.scss'],
})
export class UploadDocumentModalComponent extends BaseComponent implements OnInit, OnDestroy {
  _documentTypes: LoadDocumentType[];
  @Input() set documentTypes(value: LoadDocumentType[]) {
    if (value) {
      this._documentTypes = value.filter(
        (x) => x.description.toLowerCase() === 'other' || x.description.toLowerCase() === 'proof of delivery'
      );
    }
  }
  @Input() loadId: string;
  @Output() close: EventEmitter<boolean | LoadDocumentUpload> = new EventEmitter<boolean | LoadDocumentUpload>();
  @Output() uploadComplete: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() basicFileSelect = false;
  @Input() customDocumentUpload = false;
  selectedDocumentType: LoadDocumentType;
  comment = '';
  file: File | null = null;
  uploadDisabled = true;
  showComment = false;
  error: string;
  get documentTypes(): LoadDocumentType[] {
    return this._documentTypes;
  }

  constructor(private store: Store<SharedState>) {
    super();
  }

  ngOnInit() {
    this.store.dispatch(new LoadDocumentAddDocumentProcessedClearAction());
    this.store.pipe(select(getLoadDocumentProcessed), takeUntil(this.destroyed$)).subscribe((loaded) => {
      if (loaded) {
        this.closeModal(true);
      }
    });

    if (this.basicFileSelect) {
      // auto show the input for the user to select
      this.uploadDisabled = false;
    }
  }

  documentTypeChange(): void {
    this.showComment = false;
    this.uploadDisabled = true;

    if (this.selectedDocumentType && this.selectedDocumentType.description.toLowerCase() === 'other') {
      this.showComment = true;
    } else {
      this.uploadDisabled = false;
    }
  }
  commentChanged(text: string): void {
    this.uploadDisabled = this.comment.length === 0;
  }
  uploadDocument(event: any): void {
    this.error = null;
    if (event.target.files.length < 1) {
      return;
    }
    // capture file
    this.file = event.target.files[0];

    if (this.file.size / 1024 / 1024 > 10) {
      // file is larger than 10mb
      event.target.value = '';
      this.error = 'File is greater than 10MB.';
      return;
    }

    const payload: LoadDocumentUpload = {
      loadId: this.loadId,
      file: this.file,
      loadDocumentType: this.selectedDocumentType,
      comment: this.comment,
    };
    if (this.customDocumentUpload) {
      // let consumer handle the file update
      this.closeModal(payload);
    } else {
      this.store.dispatch(new LoadDocumentAddDocumentAction(payload));
      // this.close.emit(true);
    }

    // remove file from html input
    event.target.value = null;

    this.reset();
  }

  reset(): void {
    this.selectedDocumentType = null;
    this.uploadDisabled = !this.basicFileSelect;
    this.comment = '';
    this.showComment = false;
    this.file = null;
  }

  closeModal(payload: boolean | LoadDocumentUpload): void {
    this.close.emit(payload);
  }
}
